import { DialogViewActionWidget, SPI, ActionWidget, ActionType, Condition, ViewType } from '@kunlun/dependencies';
import { OioMessage } from '@kunlun/vue-ui-antd';
@SPI.ClassFactory(
  ActionWidget.Token({
    viewType: ViewType.Table,
    actionType: ActionType.View,
    name: ['uiClient578341900740959026-17092761325450545OUgw','uiClient519482462027130813-16951759609440944No4a'],
    model: [
      'deli.aries.platform.DeliAriesF2bPlatformItemTplPriceSaleSku',
      'deli.seller.item.DeliAriesSellerPriceSaleSku'
    ]
  })
)
export class markUpWidget extends DialogViewActionWidget {
  protected async clickAction(): Promise<void> {
    try {
      const params: any = this.parentRootData?.filter(
        (item) => item.pricingMethod && item.salesOffice && Object.keys(item.salesOffice as any).length > 0
      );
      if (params && params[0].pricingMethod && params[0]?.salesOffice) {
        this.action.context!.groupMarkupPricingMethod = `"${params[0].pricingMethod}"`;
        this.action.context!.groupMarkupSalesOfficeCode = `"${params[0].salesOffice?.['code']}"`;
        await super.clickAction();
      }
    } catch (error) {
      OioMessage.error('请先选择销售办公室与定价方式');
    }
  }
}
